export default __webpack_public_path__ + "static/taxes-a384403f2ffe6f9dcd9a52ddf63370df.mp4";